import React from 'react'
import PropTypes from 'prop-types'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import FancySelectAdvanced from '../elements/FancySelect/FancySelectAdvanced'
import InputRow from '../elements/InputRow'
import FancySelect from '../elements/FancySelect/FancySelect'
import { idStates } from '../constants'

const idTypes = [
    { value: 'DL', label: 'Drivers Licence' },
    { value: 'M', label: 'Medicare Card' },
    { value: 'P', label: 'Passport' }
]
const cardTypes = [
    { value: 'G', label: 'Green' },
    { value: 'B', label: 'Blue' },
    { value: 'Y', label: 'Yellow' }
]
const countries = require('../../data/countries.json')

const IdCheckForm = (props) => {
    const EmptyRow = () => {
        return (
            <div className='empty-row'>
                <p className='font-small sub-bold m-0 mb-1'>&nbsp;</p>
                <InputRowReadOnly value='' />
            </div>
        )
    }

    const IdNumber = placeholder => {
        return (
            <div>
                <p className='font-small sub-bold m-0 mb-1'>{placeholder}</p>
                <InputRow
                    hideLabel
                    name='idNumber'
                    value={props.values.idNumber}
                    errors={props.errors}
                    handleChange={props.handleChange}
                    placeholder={placeholder}
                    maxLength={props.values.idType === 'M' ? 10 : null}
                />
            </div>
        )
    }

    const DriversLicence = () => {
        return (
            <React.Fragment>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>State</p>
                    <FancySelect
                        list={idStates}
                        setValue={value => props.setDynamicValues({ idState: value })}
                        label='State'
                        value={props.values.idState}
                        className={props.errors && props.errors.idState ? 'error' : ''}
                    />
                </div>
                {IdNumber('Licence no.')}
            </React.Fragment>
        )
    }

    const Passport = () => {
        return (
            <React.Fragment>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>Country</p>
                    <FancySelectAdvanced
                        list={countries}
                        setValue={value => props.setDynamicValues({ country: value })}
                        label='Country'
                        value={props.values.country}
                        className={props.errors && props.errors.country ? 'error' : ''}
                    />
                </div>
                {IdNumber('Passport no.')}
            </React.Fragment>
        )
    }

    const Medicare = () => {
        return (
            <React.Fragment>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>Card colour</p>
                    <FancySelectAdvanced
                        list={cardTypes}
                        setValue={value => props.setDynamicValues({ cardType: value })}
                        label='Card Colour'
                        value={props.values.cardType}
                        className={props.errors && props.errors.cardType ? 'error' : ''}
                    />
                </div>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>Individual ref number</p>
                    <InputRow
                        hideLabel
                        name='individualRefNumber'
                        value={props.values.individualRefNumber}
                        errors={props.errors}
                        handleChange={props.handleChange}
                        placeholder='No. beside your name'
                        maxLength={1}
                    />
                </div>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>Expiry date</p>
                    <InputRow
                        hideLabel
                        name='idExpiry'
                        value={props.values.idExpiry}
                        errors={props.errors}
                        handleChange={props.handleChange}
                        placeholder={props.values.cardType === 'G' ? 'MM/YYYY' : 'DD/MM/YYYY'}
                        maxLength={props.values.cardType === 'G' ? 7 : 10}
                    />
                </div>
            </React.Fragment>
        )
    }

    const NameFields = () => {
        return (
            <React.Fragment>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>First name</p>
                    <InputRow
                        hideLabel
                        name='firstName'
                        value={props.values.firstName}
                        errors={props.errors}
                        handleChange={props.handleChange}
                        placeholder='First name'
                        handleOnBlur={props.handleBlurFirstName}
                    />
                </div>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>Middle name</p>
                    <InputRow
                        hideLabel
                        name='middleName'
                        value={props.values.middleName}
                        errors={props.errors}
                        handleChange={props.handleChange}
                        placeholder='(optional)'
                    />
                </div>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>Last name</p>
                    <InputRow
                        hideLabel
                        name='lastName'
                        value={props.values.lastName}
                        errors={props.errors}
                        handleChange={props.handleChange}
                        placeholder='Last name'
                        handleOnBlur={props.handleBlurLastName}
                    />
                </div>
            </React.Fragment>
        )
    }

    const MedicareNameField = () => {
        return (
            <React.Fragment>
                <div>
                    <p className='font-small sub-bold m-0 mb-1'>Your name</p>
                    <InputRow
                        hideLabel
                        name='fullName'
                        value={props.values.fullName}
                        errors={props.errors}
                        handleChange={props.handleChange}
                        placeholder='Exact name as it appears on Medicare Card'
                    />
                </div>
                {DobField()}
            </React.Fragment>
        )
    }

    const DobField = () => {
        return (
            <div>
                <p className='font-small sub-bold m-0 mb-1'>Date of birth</p>
                <InputRow
                    hideLabel
                    name='dateOfBirth'
                    value={props.values.dateOfBirth}
                    errors={props.errors}
                    handleChange={props.handleChangeDob}
                    placeholder='DD/MM/YYYY'
                    autocomplete='bday'
                />
            </div>
        )
    }

    return (
        <div>
            <div className='mb-4'>
                <InputRowReadOnly value={`${props.firstName} ${props.lastName}`} label='Account holder' />
            </div>

            <div className='mb-4'>
                <label className='bold mb-3 d-inline-block'>Select your ID document</label>
                <div className='id-documents d-flex mb-1 mb-md-4'>
                    <div>
                        <p className='font-small sub-bold m-0 mb-1'>ID type</p>
                        <FancySelectAdvanced
                            list={idTypes}
                            setValue={value => props.handleChangeIdType(value)}
                            label='ID type'
                            value={props.values.idType}
                            className={props.errors && props.errors.idType ? 'error' : ''}
                        />
                    </div>
                    {!props.values.idType
                        ? <React.Fragment>
                            <EmptyRow />
                            <EmptyRow />
                          </React.Fragment>
                        : ''}
                    {props.values.idType === 'DL' ? DriversLicence() : ''}
                    {props.values.idType === 'P' ? Passport() : ''}
                    {props.values.idType === 'M' ? IdNumber('Medicare card no.') : ''}
                </div>
                {props.values.idType === 'M'
                    ? <div className='id-documents-medicare d-flex mt-lg-3 mb-4'>
                        {Medicare()}
                      </div>
                    : ''}
                 {props.values.idType === "DL"
                    ? <div>
                        <p className="font-small sub-bold m-0 mb-1">Card number</p>
                        <div className={`personal-details d-flex mb-1 mb-md-4`}>
                        <InputRow
                            hideLabel
                            name="cardNumber"
                            value={props.values.cardNumber}
                            errors={props.errors}
                            handleChange={props.handleChange}
                            placeholder="Card number"
                            maxLength={25}
                        />
                      </div>
                    </div>
                     : ''}
            </div>

            <div className='mb-4'>
                <label className='bold mb-3 d-inline-block'>Personal details as appear on your ID</label>
                <div className={`personal-details ${props.values.idType === 'M' ? 'is-medicare' : ''} d-flex mb-1 mb-md-4`}>
                    {props.values.idType === 'M' ? MedicareNameField() : NameFields()}
                </div>
                {props.values.idType !== 'M'
                    ? <div className='personal-details d-flex'>
                        {DobField()}
                      </div>
                    : ''}
            </div>
        </div>
    )
}

IdCheckForm.propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    setDynamicValues: PropTypes.func.isRequired,
    handleChangeDob: PropTypes.func.isRequired,
    handleChangeIdType: PropTypes.func.isRequired,
    handleBlurFirstName: PropTypes.func,
    handleBlurLastName: PropTypes.func
}

IdCheckForm.defaultProps = {
    handleBlurFirstName: () => {},
    handleBlurLastName: () => {}
}

export default IdCheckForm



// WEBPACK FOOTER //
// ./resources/js/components/IdCheckForm.js